// obj_valExist_fb
export const obj_valExist_fb = (obj, val) => {

    let values = Object.values(obj)

    return values.indexOf(val) > -1
}

// obj_forEach_f
export const obj_forEach_f = (obj, cb) => {
    if(obj == null){return}

    let index_n = 0;
    for (let key in obj) {
        cb(obj[key], key, index_n)
        index_n++;
    }
}

// obj_vFor_f
export const obj_vFor_f = (obj, cb) => {
    if(obj == null){return}

    let ans = ""
    let index_n = 0;
    for (let key in obj) {
        ans += cb(obj[key], key, index_n)
        index_n++;
    }
    return ans
}

//obj_map_fo
export const obj_map_fo = (obj, cb) => {

    let ans= {}
    for (let key in obj) {
        if(obj[key] != null){
            ans[key] = cb(obj[key],key)
        }
    }
    return ans

}

//obj_mapValues_fo
export const obj_mapValues_fo = (obj, cb) => {

    let ans= {}
    for (let key in obj) {
        ans[obj[key]] = cb(obj[key],key)
    }
    return ans

}

//obj_toArray_fo
export const obj_toArray_fo = (obj) => {
    if(obj ==null){
        return []
    }
    return Object.values(obj)
}

// obj_toKeysArray_fo
export const obj_toKeysArray_fo = (obj) => {
    return Object.keys(obj)
}

//obj_toString_fs
export const obj_toString_fs = (obj) => {

    let ans= "{"
    for (let key in obj) {
        ans += key + "=" +obj[key] + ";"
    }
    return ans + "}"

}

// obj_equals2_fb
export const obj_equals_fb = (x, y, onlyOneSide_b = false) => {


    if ( x === y ) return true;
    // if both x and y are null or undefined and exactly the same

    if ( ! ( x instanceof Object ) || ! ( y instanceof Object ) ) return false;
    // if they are not strictly equal, they both need to be Objects

    if ( x.constructor !== y.constructor ) return false;
    // they must have the exact same prototype chain, the closest we can do is
    // test there constructor.

    for ( var p in x ) {
        if ( ! x.hasOwnProperty( p ) ) continue;
        // other properties were tested using x.constructor === y.constructor

        if ( ! y.hasOwnProperty( p ) ) return false;
        // allows to compare x[ p ] and y[ p ] when set to undefined

        if ( x[ p ] === y[ p ] ) continue;
        // if they have the same strict value or identity then they are equal

        if ( typeof( x[ p ] ) !== "object" ) return false;
        // Numbers, Strings, Functions, Booleans must be strictly equal

        if ( ! obj_equals_fb( x[ p ],  y[ p ] ) ) return false;
        // Objects and Arrays must be tested recursively
    }

    for ( p in y ) {
        if ( y.hasOwnProperty( p ) && ! x.hasOwnProperty( p ) ) return false;
        // allows x[ p ] to be set to undefined
    }
    return true;

    // return JSON.stringify(obj1) === JSON.stringify(obj2)
}

// obj_size_fn
export const obj_size_fn = (obj) => {
    if (!obj)
        return 0

    return Object.keys(obj).length;
}

// obj_lastIndex_f
export const obj_lastIndex_f = (obj) => {
    if (obj == null)
        return -1

    let keys = Object.keys(obj)

    return keys[keys.length - 1];
}

// obj_deepCopy_f
export const obj_deepCopy_f = (obj) => {
    if (!obj)
        return obj

    return JSON.parse(JSON.stringify(obj))
}

// obj_deepCopy_f2
export const obj_deepCopy_f2 = (obj1, obj2) => {

    Object.assign(obj1, obj2);
}